
// Translation file for reusable components

export const components = {
  // Button labels
  buttons: {
    details: "Details",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    submit: "Submit",
    export: "Export",
    add: "Add",
  },
  
  // Common card elements
  cards: {
    balance: {
      title: "Your current balance",
      description: "We pay out every week if your balance reaches 1000 HUF!",
      explanation: "How your balance works"
    }
  },
  
  // Status labels
  status: {
    active: "Active",
    inactive: "Inactive",
    new: "New",
    accepted: "Accepted",
    completed: "Completed",
    rejected: "Rejected"
  },
};
